import { t as __t } from "i18next";
import React, { useState, useEffect, useRef } from "react";
import { notifyListRefresh } from "../../../utils/listNavigation";
import { useDispatch, useSelector } from "react-redux";
import {
	callGenerateCode, callAddAgent,
	callEditAgent, callGetAgentById
} from "../../../api/callcenters/service"
import { AsyncPaginate } from "react-select-async-paginate";
import { callGetAllProvince, callGetDistrict, callGetVehicleBrand, callSearchAgentInfo, callUploadFile } from "../../../api/settings/service"
import CopyrightFooter from "../../../components/footer/employers/CopyrightFooter";
import DashboardHeader from "../../../components/header/DashboardHeader";
import BackPrevious from "../../../components/back-previous";
import DashboardEmployerSidebar from "../../../components/header/DashboardSidebar";
import MobileMenu from "../../../components/header/MobileMenu";
import "../../../components/i18n/lang";
import { decodeBase64, handleGetCookie, displayUrl, FormatCurrencys, getDeviceId, relation, FormatCurrency, calculateAge, convertStringToJson, dateToString, parseDbValueToArray } from "../../../utils/commonUtil"
import { useTranslation } from "react-i18next";
import { useParams, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import colors from '../../../utils/colors'
import moment from "moment";
import documentType from "../../../data/documentType"
import agentType from "../../../data/agentType"
import { QRCodeCanvas } from 'qrcode.react';
import { subscribeToPubNub } from '../../../utils/pubnubService';
import { toast } from "react-toastify";
import DataAutoComplete from "../../../components/auto-complete";
import { addLifeContract, addVehicleContract, callGetActivePackage, callGetActiveVehiclePackage, callGetActiveVehicleType, callGetContractByKey, editLifeContract, editVehiclesContract, getLifeContract, getVehiclesContract } from "../../../api/contract/service";
import SwalAlert from "../../../components/common/alert";
import FilterableSelect from "../../../components/common/select-component";
import FilterableDropdown from "../../../components/common/select-component";
import Checkbox from "../../../components/common/checkBox";
import FileUploadGrid from "../../../components/upload-file";
import PaymentPage from "./pay";
import InputNumberFormat from "../../../components/input";
import { callPaymentCheckByBillNumber } from "../../../api/insurances/service";

const Index = () => {
	const userInfo = useSelector((state) => state.dataLogin);
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const { t } = useTranslation();
	const [dateOfBirth, setDateOfBirth] = useState(null);
	const [issueDate, setIssueDate] = useState(null);
	const [vehicleBrandList, setVehicleBrandList] = useState([]);
	const [agent, setAgent] = useState([]);
	const saveButtonRef = useRef(null);
	const [isStickyVisible, setStickyVisible] = useState(false);
	const [agentData, setAgentData] = useState(null);
	const debounceTimeout = useRef(null);


	const [request, setRequest] = useState({
		contractNumber: null,
		insuranceType: 2,
		package: null,
		packageId: '',
		packageType: '',
		isRenew: 2,
		channel: 'staff on web',
		userId: userInfo?.data?.user?.userId,
		carriedCode: userInfo?.data?.user?.userId,
		carriedName: userInfo?.data?.user?.firstName + " " + (userInfo?.data?.user?.lastName === null ? '' : userInfo?.data?.user?.lastName),
		deviceId: getDeviceId(),
		isVip: false,
		centerAmount: [],
		vipAmount: 0,
		discount: 0,
		vipPercent: 0,
		guaranteenFeeArray: [],
		guaranteenFee: null,
		vehiclesLegal: 0,
		customer: {
			isVerify: '0',
			firstName: '',
			lastName: '',
			gender: 'm',
			dateOfBirth: '',
			age: 30,
			documentTypeId: '',
			documentNo: '',
			issueDate: '',
			expiredDate: '',
			issuePlace: '',
			documentImagePath: null,
			phone: '',
			provinceId: '',
			districtId: '',
			homeNumber: '',
			unitNumber: '',
			village: '',
			file: null
		},
		vehicle: {
			vehicleBrand: null,
			vehicleBrandId: '',
			vehicleModel: '',
			licensePlate: '',
			vehiclePower: '',
			engineNo: '',
			vehicleIdentificationNo: '',
			imagePath: '',
			isRepairCenter: false,
			file: null
		},

	})
	const [selectedFile, setSelectedFile] = useState(null);
	const fileInputRef = useRef({});

	const [provinceList, setProvinceList] = useState([]);
	const [packageListType, setPackageListType] = useState([]);
	const [packageListTerm, setPackageListTerm] = useState([]);

	const [packageList, setPackageList] = useState([]);

	const [districtList, setDistrictList] = useState({ customer: [], heirs1: [], heirs2: [] });


	const [qrCode, setQRCode] = useState({
		vipAmount: 0,
		discountPercent: 0,
		value: '', transactionId: '', total: 0
	});
	let params = useParams();

	useEffect(() => {
		if (Object.keys(params).length > 0) {
			let id = decodeBase64(params?.id)
			if (id != null) {
				setRequest((prev) => ({
					...prev, contractNumber: id
				}));
				intialData(id)
			}
		} else {
			if (userInfo?.data?.user?.agentId) setAgentData({ agentCode: (userInfo?.data?.user?.agentId ? userInfo?.data?.user?.agentId : "") })
		}

		setRequest((prev) => ({
			...prev,
			userId: userInfo?.data?.user?.userId,
			carriedCode: userInfo?.data?.user?.userId,
			carriedName: userInfo?.data?.user?.firstName + " " + (userInfo?.data?.user?.lastName === null ? '' : userInfo?.data?.user?.lastName),
		}));

		loadProvince();
		loadPackageType()
		const handleScroll = () => {
			if (saveButtonRef.current) {
				const rect = saveButtonRef.current.getBoundingClientRect();
				setStickyVisible(rect.bottom > 980); // ปุ่มหลุดจาก view
			}
		};
		window.addEventListener('scroll', handleScroll);
		return () => window.removeEventListener('scroll', handleScroll);
	}, [userInfo]);

	useEffect(() => {
		// let pubData = subscribeToPubNub(qrCode.transactionId, null, null);
		// if (pubData) {
		// 	pubData.addListener({
		// 		message: (event) => {
		// 			console.log('Message received:', event.message);
		// 			if (event.message?.transactionId) {
		// 				toast.success("Thank you! Your payment has been received", {
		// 					position: "top-left",
		// 				});

		// 				setQRCode({
		// 					value: '',
		// 					total: 0,
		// 				});
		// 				notifyListRefresh();
					navigate('/admin/contractControl/vehicleInsurance')

		// 			}
		// 		},
		// 		status: (statusEvent) => {
		// 			console.log("PubNub status:", statusEvent);
		// 		},
		// 	});
		// }

		// return () => {
		// 	pubData?.unsubscribeAll();
		// };
	}, [qrCode.transactionId]);



	const loadProvince = async () => {
		const rsp = await dispatch(callGetAllProvince());
		if (rsp?.payload?.responseCode === "00000") {
			setProvinceList(rsp?.payload?.data)
		}
	}
	const loadPackageType = async () => {
		const rsp = await dispatch(callGetActiveVehicleType());
		if (rsp?.payload?.responseCode === "00000") {
			setPackageListType(rsp?.payload?.data)
		}
	}
	const loadPackage = async (id) => {
		const rsp = await dispatch(callGetActiveVehiclePackage({ vehiclesTypeId: id }));
		if (rsp?.payload?.responseCode === "00000") {
			const uniqueTerms = [...new Set(rsp?.payload?.data.map(item => item.term))];
			setPackageListTerm(uniqueTerms)
			setPackageList(rsp?.payload?.data)
			return rsp?.payload?.data
		}
		return null
	}
	const loadBrand = async (search, loadedOptions, { page }) => {
		let data = { page: page, maxResult: 10, keyword: search };
		const rsp = await dispatch(callGetVehicleBrand(data));
		if (rsp?.payload?.responseCode === "00000") {
			setVehicleBrandList(rsp.payload.data.result);
			return {
				options: rsp.payload.data.result.map((item) => ({
					value: item.brandId,
					label: item.brandNameEn,
				})),
				hasMore: rsp.payload.data.totalRecords > loadedOptions.length,   // บอกว่ายังมีต่อหรือไม่
				additional: {
					page: page + 1,        // next page
				}
			}
		}
	};
	const intialData = async (id) => {
		const res = await dispatch(getVehiclesContract({ contractNo: id }))
		if (res?.payload?.responseCode === "00000") {
			loadDistrict(res?.payload?.data?.customer.provinceId, 'customer');
			let pk = await loadPackage(res?.payload?.data?.vehicleTypeId)
			if (res?.payload?.data?.agentId) setAgentData({ agentCode: res?.payload?.data?.agentId })
			setRequest((prev) => ({
				...prev,
				customer: res?.payload?.data?.customer,
				customerId: res?.payload?.data?.customer.customerId,
				vehicle: {
					...res?.payload?.data,
					isRepairCenter: res?.payload?.data?.isRepairCenter === "1" ? true : false,
					imagePath: res?.payload?.data?.imagePath ? convertStringToJson(res?.payload?.data?.imagePath) : ''
				},
				packageType: res?.payload?.data?.vehicleTypeId,
				packageId: res?.payload?.data?.packageId,
				package: pk?.find((item) => item.packageId === res?.payload?.data?.packageId),
				userId: userInfo?.data?.user?.userId,
				carriedCode: userInfo?.data?.user?.userId,
				carriedName: userInfo?.data?.user?.firstName + " " + (userInfo?.data?.user?.lastName === null ? '' : userInfo?.data?.user?.lastName),
			}));
			onChangePackage({ ...pk?.find((item) => item.packageId === res?.payload?.data?.packageId), agentId: res?.payload?.data?.agentId })


		}
	}

	const handleChange = (e, key) => {
		let { name, value, type } = e.target;
		if (['discount', 'vipAmount'].includes(name)) {
			let ss = e.target.value.replace(/,/g, '');
			if (isNaN(ss)) return;
			value = Number(ss).toLocaleString()
		}
		if (key) {
			setRequest((prev) => ({
				...prev,
				[key]: {
					...prev[key],
					[name]: name === 'isRepairCenter' ? e.target.checked : value
				}
			})
			);
			if (name === 'provinceId') {
				loadDistrict(e.target.value, key);
			}
		} else {
			setRequest((prev) => ({
				...prev,
				[name]: name === 'isVip' ? e.target.checked : value
			}))
		}
	};
	const handleIsVIP = async (e) => {
		clearTimeout(debounceTimeout.current);
		if (!e.target.checked) {
			let reqUpdate = {
				...request,
				package: request.package,
				packageId: request.package.packageId,
				isVip: e.target.checked ? 1 : 0,
				customer: { ...request.customer },
				vehicle: { ...request.vehicle },
				step: 1,
			}
			debounceTimeout.current = setTimeout(async () => {
				{
					console.log(reqUpdate)
					const rsp = await dispatch(addVehicleContract(reqUpdate));
					if (rsp?.payload?.responseCode === "00000") {
						console.log(rsp?.payload?.calculate)
						setQRCode({
							step: 1,
							transactionId: rsp?.payload?.calculate?.transactionId,
							RVPEAmount: rsp?.payload?.calculate?.RVPEAmount,
							priceAfterDiscount: rsp?.payload?.calculate?.priceAfterDiscount,
							sumTotal: rsp?.payload?.calculate?.sumTotal,

							total: rsp?.payload?.calculate?.totalAmount,
							payPerMonth: rsp?.payload?.calculate?.packagePrice,
							feeRegister: rsp?.payload?.calculate?.registerFee,
							total: rsp?.payload?.calculate?.totalAmount,
							discount: rsp?.payload?.calculate?.discount,
							vat: rsp?.payload?.calculate?.vat,
							vatValue: rsp?.payload?.calculate?.vatValue,
							commission: rsp?.payload?.calculate?.commission,
							commissionRate: rsp?.payload?.calculate?.commissionRate,
							vipAmount: rsp?.payload?.calculate?.vipAmount || 0,
							discountPercent: request.discount,
							paymentFee: rsp?.payload?.calculate?.paymentFee,
							repairCost: rsp?.payload?.calculate?.repairCost,
							companyReceiveTotal: rsp?.payload?.calculate?.companyReceiveTotal,
							civelLiability: rsp?.payload?.calculate?.civelLiability,
							guaranteenFee: rsp?.payload?.calculate?.guaranteenFee
						})
					}
				}
			}, 500);
		}
	};
	const handleVIP = async (e, key) => {
		clearTimeout(debounceTimeout.current);
		const { name, value } = e.target;
		if ((Number(value.replace(/,/g, '')) === qrCode.vipAmount) || (!qrCode.vipAmount && value == "0")) {
			return
		}

		let reqUpdate = {
			...request,
			package: request.package,
			packageId: request.package.packageId,
			isVip: request.isVip ? 1 : 0,
			customer: { ...request.customer },
			vehicle: { ...request.vehicle },
			vipAmount: Number(value.replace(/,/g, '')),
			step: 1,
		}
		debounceTimeout.current = setTimeout(async () => {
			{
				console.log(reqUpdate)
				const rsp = await dispatch(addVehicleContract(reqUpdate));
				if (rsp?.payload?.responseCode === "00000") {
					console.log(rsp?.payload?.calculate)
					setQRCode({
						step: 1,
						transactionId: rsp?.payload?.calculate?.transactionId,
						RVPEAmount: rsp?.payload?.calculate?.RVPEAmount,
						priceAfterDiscount: rsp?.payload?.calculate?.priceAfterDiscount,
						sumTotal: rsp?.payload?.calculate?.sumTotal,

						total: rsp?.payload?.calculate?.totalAmount,
						payPerMonth: rsp?.payload?.calculate?.packagePrice,
						feeRegister: rsp?.payload?.calculate?.registerFee,
						total: rsp?.payload?.calculate?.totalAmount,
						discount: rsp?.payload?.calculate?.discount,
						vat: rsp?.payload?.calculate?.vat,
						vatValue: rsp?.payload?.calculate?.vatValue,
						commission: rsp?.payload?.calculate?.commission,
						commissionRate: rsp?.payload?.calculate?.commissionRate,
						vipAmount: rsp?.payload?.calculate?.vipAmount || 0,
						discountPercent: request.discount,
						paymentFee: rsp?.payload?.calculate?.paymentFee,
						repairCost: rsp?.payload?.calculate?.repairCost,
						companyReceiveTotal: rsp?.payload?.calculate?.companyReceiveTotal,
						civelLiability: rsp?.payload?.calculate?.civelLiability,
						guaranteenFee: rsp?.payload?.calculate?.guaranteenFee
					})
				}
			}
		}, 500);
	};
	const handleChangeVehicleBrandId = (e) => {
		setRequest((prev) => ({
			...prev,
			vehicle: {
				...prev.vehicle,
				vehicleBrand: e,
				vehicleBrandId: e?.value || ''
			}
		}))
	};
	const onChangePackage = async (e) => {
		setRequest((prev) => ({
			...prev,
			package: e,
			guaranteenFeeArray: parseDbValueToArray(e?.guaranteenFee),
			centerAmount: convertStringToJson(e?.centerAmount) || [],
			packageId: e.packageId,
			isRepairCenter: -1,
			vehiclesLegal: 0,
			vipAmount: 0,
			isVip: false,
			vipPercent: 0,
			guaranteenFee: null

		}))
		let reqUpdate = {
			...request,
			package: e,
			packageId: e.packageId,
			isVip: request.isVip ? "1" : "0",
			customer: { ...request.customer },
			vehicle: { ...request.vehicle },
			discount: request.discount,
			step: 1,
			agentId: e?.agentId || ''
		}
		const rsp = await dispatch(addVehicleContract(reqUpdate));
		if (rsp?.payload?.responseCode === "00000") {
			setQRCode({
				transactionId: rsp?.payload?.calculate?.transactionId,
				total: rsp?.payload?.calculate?.totalAmount,
				payPerMonth: rsp?.payload?.calculate?.packagePrice,
				feeRegister: rsp?.payload?.calculate?.registerFee,
				total: rsp?.payload?.calculate?.totalAmount,
				discount: rsp?.payload?.calculate?.packagePrice * request.discount / 100,
				vat: rsp?.payload?.calculate?.vat,
				vatValue: rsp?.payload?.calculate?.vatValue,
				commission: rsp?.payload?.calculate?.commission,
				commissionRate: rsp?.payload?.calculate?.commissionRate,
				vipAmount: rsp?.payload?.calculate?.vipAmount || 0,
				discountPercent: request.discount,
				commission: rsp?.payload?.calculate?.commission,
				repairCost: rsp?.payload?.calculate?.repairCost,
				companyReceiveTotal: rsp?.payload?.calculate?.companyReceiveTotal,
				civelLiability: rsp?.payload?.calculate?.civelLiability,
				guaranteenFee: rsp?.payload?.calculate?.guaranteenFee
			})
		}

	}


	const selectedDistrict = (e) => {
		e.preventDefault();
		setRequest((prev) => ({
			...prev,
			customer: {
				...prev.customer,
				districtId: e.target.value
			}
		}));
	}

	const loadDistrict = async (proId, key) => {
		const rs = await dispatch(callGetDistrict({ provinceId: proId }));
		if (rs?.payload?.responseCode === "00000") {
			console.log(key)
			setDistrictList((prev) => ({
				...prev,
				[key]: rs?.payload?.data
			}))
		}
	}

	const selectedDocument = (e) => {
		e.preventDefault();
		setRequest((prev) => ({
			...prev,
			customer: {
				...prev.customer,
				documentTypeId: e.target.value
			}
		}));
	}

	const selectePackageType = async (e) => {
		e.preventDefault();
		if (!e.target.value) {
			setRequest((prev) => ({
				...prev,
				packageId: "",
				packageType: ""

			}));
			return
		}
		setRequest((prev) => ({
			...prev,
			packageType: e.target.value

		}));
		loadPackage(e.target.value)
	}

	const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));
	const maxTime = 120;

	const checkPaymentUntilSuccess = async (billNumber) => {
		const maxTimV = maxTime * 1000; // 1 ນາທີ
		const interval = 3 * 1000; // 3 ວິນາທີ
		const startTime = Date.now();

		while (Date.now() - startTime < maxTimV) {
			try {
				const rsp = await dispatch(callPaymentCheckByBillNumber({ billNumber: billNumber }));

				console.log("check payment result:", rsp);

				// ປັບຕາມ response ຂອງ API ເຈົ້າ
				if (rsp?.payload?.responseCode === "00000") {
					notifyListRefresh();
					navigate('/admin/contractControl/vehicleInsurance')
					return {
						success: true,
						data: null,
						message: ""
					};
				}
				await sleep(interval);
			} catch (error) {
				console.log("check payment error:", error);
				await sleep(interval);
			}
		}

		return {
			success: false,
			data: null,
			message: __t("uiText.text294")
		};
	};
	const handleSave = async (e) => {
		console.log(request)
		e.preventDefault()
		if (!request.guaranteenFee && request.guaranteenFeeArray.length > 0) {
			SwalAlert.error(__t("uiText.text023"), __t("uiText.text296"));
			return;
		}
		SwalAlert.confirm(t("nameSave"), t("confirmSave"), async () => {
			try {
				let reqUpdate = {
					...request,
					isVip: request.isVip ? "1" : "0",
					customer: { ...request.customer },
					vehicle: { ...request.vehicle, imagePath: JSON.stringify(request.vehicle.imagePath) },
					step: 2
				}
				const rsp = await dispatch(addVehicleContract(reqUpdate));
				if (rsp?.payload?.responseCode === "00000") {
					setQRCode({
						value: rsp?.payload?.data,
						transactionId: rsp?.payload?.calculate?.transactionId,
						total: rsp?.payload?.calculate?.totalAmount,
						payPerMonth: rsp?.payload?.calculate?.packagePrice,
						feeRegister: rsp?.payload?.calculate?.registerFee,
						total: rsp?.payload?.calculate?.totalAmount,
						discount: rsp?.payload?.calculate?.discount,
						vat: rsp?.payload?.calculate?.vat,
						vatValue: rsp?.payload?.calculate?.vatValue,
						commission: rsp?.payload?.calculate?.commission,
						commissionRate: rsp?.payload?.calculate?.commissionRate,
						vipAmount: rsp?.payload?.calculate?.vipAmount || 0,
						discountPercent: request.discount,
						commission: rsp?.payload?.calculate?.commission,
						repairCost: rsp?.payload?.calculate?.repairCost,
						companyReceiveTotal: rsp?.payload?.calculate?.companyReceiveTotal,
						civelLiability: rsp?.payload?.calculate?.civelLiability,
						guaranteenFee: rsp?.payload?.calculate?.guaranteenFee
					})
					const check = await checkPaymentUntilSuccess(rsp?.payload?.calculate?.billNumber)
					if (!check.success) {
						notifyListRefresh();
					navigate('/admin/contractControl/vehicleInsurance')
						return;
					}
				} else {
					SwalAlert.error(__t("uiText.text023"), rsp?.payload?.responseCode + " - " + rsp?.payload?.responseDescription);
				}
			} catch (error) {
				SwalAlert.error(__t("uiText.text023"), __t("uiText.text024"),);
			}
		})

	}

	const triggerFileInput = (key) => {
		fileInputRef.current[key].click();

	};

	const cancelSeletedFile = (key) => {
		setRequest((prev) => ({
			...prev,
			[key]: {
				...prev[key],
				file: null
			}
		}));
	};


	const handleImageSelect = (e, key) => {
		setRequest((prev) => ({
			...prev,
			[key]: {
				...prev[key],
				file: { file: e }
			}
		}));
	};
	const handleDateChange = (date, field, key) => {
		setRequest((prev) => ({
			...prev,
			[key]: {
				...prev[key],
				[field]: moment(date).format('YYYY-MM-DD'),
			}
		}));
	};
	const loadData = async (value) => {
		if (value?.id) {
			let data = { keyword: null, page: 1, maxResult: 1, agentId: value?.id };
			const rsp = await dispatch(callSearchAgentInfo(data));
			if (rsp?.payload?.responseCode === "00000" && rsp?.payload?.data?.result.length >= 1) {
				setAgent(rsp.payload.data.result)
			}

		} else {
			let data = { keyword: value, page: 1, maxResult: 10, agentId: null };
			const rsp = await dispatch(callSearchAgentInfo(data));
			if (rsp?.payload?.responseCode === "00000" && rsp?.payload?.data?.result.length >= 1) {
				setAgent(rsp.payload.data.result)
			}
		}
	};

	const onSelect = async (item) => {
		if (item) {
			setRequest((prev) => ({
				...prev,
				agent: item,
				agentId: item.agentId
			}));
		} else {
			setRequest((prev) => ({
				...prev,
				agent: null,
				agentId: null
			}));
		}
	}
	const handleChangeCarType = async (e) => {
		const { name, value } = e.target;
		let reqUpdate = {
			...request,
			package: request.package,
			packageId: request.package.packageId,
			isVip: request.isVip ? "1" : "0",
			customer: { ...request.customer },
			vehicle: { ...request.vehicle },
			discount: request.discount,
			isEVCar: value,
			step: 1,
		}
		const rsp = await dispatch(addVehicleContract(reqUpdate));
		if (rsp?.payload?.responseCode === "00000") {
			setQRCode({
				step: 1,
				transactionId: rsp?.payload?.calculate?.transactionId,
				RVPEAmount: rsp?.payload?.calculate?.RVPEAmount,
				sumTotal: rsp?.payload?.calculate?.sumTotal,
				priceAfterDiscount: rsp?.payload?.calculate?.priceAfterDiscount,
				total: rsp?.payload?.calculate?.totalAmount,
				payPerMonth: rsp?.payload?.calculate?.packagePrice,
				feeRegister: rsp?.payload?.calculate?.registerFee,
				total: rsp?.payload?.calculate?.totalAmount,
				discount: rsp?.payload?.calculate?.discount,
				vat: rsp?.payload?.calculate?.vat,
				vatValue: rsp?.payload?.calculate?.vatValue,
				commission: rsp?.payload?.calculate?.commission,
				commissionRate: rsp?.payload?.calculate?.commissionRate,
				vipAmount: rsp?.payload?.calculate?.vipAmount || 0,
				discountPercent: request.discount,
				paymentFee: rsp?.payload?.calculate?.paymentFee,
				repairCost: rsp?.payload?.calculate?.repairCost,
				companyReceiveTotal: rsp?.payload?.calculate?.companyReceiveTotal,
				civelLiability: rsp?.payload?.calculate?.civelLiability,
				guaranteenFee: rsp?.payload?.calculate?.guaranteenFee
			})
		}
		setRequest((prev) => ({
			...prev,
			[name]: value
		}))
	};
	const handleChangeCenterAmount = async (e, key) => {
		const { name, value } = e.target;
		if (key) {
			setRequest((prev) => ({
				...prev,
				[key]: {
					...prev[key],
					[name]: name === 'isRepairCenter' ? (e.target.value == "-1" ? null : e.target.value) : value
				}
			})
			);
		}
		let reqUpdate = {
			...request,
			package: request.package,
			packageId: request.package.packageId,
			isVip: request.isVip ? "1" : "0",
			customer: { ...request.customer },
			vehicle: { ...request.vehicle, isRepairCenter: (e.target.value == "-1" ? null : e.target.value) },
			discount: request.discount,
			step: 1,
		}
		const rsp = await dispatch(addVehicleContract(reqUpdate));
		if (rsp?.payload?.responseCode === "00000") {
			setQRCode({
				step: 1,
				transactionId: rsp?.payload?.calculate?.transactionId,
				RVPEAmount: rsp?.payload?.calculate?.RVPEAmount,
				sumTotal: rsp?.payload?.calculate?.sumTotal,
				priceAfterDiscount: rsp?.payload?.calculate?.priceAfterDiscount,
				total: rsp?.payload?.calculate?.totalAmount,
				payPerMonth: rsp?.payload?.calculate?.packagePrice,
				feeRegister: rsp?.payload?.calculate?.registerFee,
				total: rsp?.payload?.calculate?.totalAmount,
				discount: rsp?.payload?.calculate?.discount,
				vat: rsp?.payload?.calculate?.vat,
				vatValue: rsp?.payload?.calculate?.vatValue,
				commission: rsp?.payload?.calculate?.commission,
				commissionRate: rsp?.payload?.calculate?.commissionRate,
				vipAmount: rsp?.payload?.calculate?.vipAmount || 0,
				discountPercent: request.discount,
				paymentFee: rsp?.payload?.calculate?.paymentFee,
				repairCost: rsp?.payload?.calculate?.repairCost,
				companyReceiveTotal: rsp?.payload?.calculate?.companyReceiveTotal,
				civelLiability: rsp?.payload?.calculate?.civelLiability,
				guaranteenFee: rsp?.payload?.calculate?.guaranteenFee
			})
		}
	};
	const handleChangeDiscount = async (e, key) => {
		clearTimeout(debounceTimeout.current);
		const { name, value } = e.target;
		let reqUpdate = {
			...request,
			package: request.package,
			packageId: request.package.packageId,
			isVip: request.isVip ? 1 : 0,
			customer: { ...request.customer },
			vehicle: { ...request.vehicle },
			vipAmount: request.vipAmount,
			discount: value,
			step: 1,
		}
		debounceTimeout.current = setTimeout(async () => {
			{
				console.log(reqUpdate)
				const rsp = await dispatch(addVehicleContract(reqUpdate));
				if (rsp?.payload?.responseCode === "00000") {
					console.log(rsp?.payload?.calculate)
					setQRCode({
						step: 1,
						transactionId: rsp?.payload?.calculate?.transactionId,
						RVPEAmount: rsp?.payload?.calculate?.RVPEAmount,
						priceAfterDiscount: rsp?.payload?.calculate?.priceAfterDiscount,
						sumTotal: rsp?.payload?.calculate?.sumTotal,

						total: rsp?.payload?.calculate?.totalAmount,
						payPerMonth: rsp?.payload?.calculate?.packagePrice,
						feeRegister: rsp?.payload?.calculate?.registerFee,
						total: rsp?.payload?.calculate?.totalAmount,
						discount: rsp?.payload?.calculate?.discount,
						vat: rsp?.payload?.calculate?.vat,
						vatValue: rsp?.payload?.calculate?.vatValue,
						commission: rsp?.payload?.calculate?.commission,
						commissionRate: rsp?.payload?.calculate?.commissionRate,
						vipAmount: rsp?.payload?.calculate?.vipAmount || 0,
						discountPercent: request.discount,
						paymentFee: rsp?.payload?.calculate?.paymentFee,
						repairCost: rsp?.payload?.calculate?.repairCost,
						companyReceiveTotal: rsp?.payload?.calculate?.companyReceiveTotal,
						civelLiability: rsp?.payload?.calculate?.civelLiability,
						guaranteenFee: rsp?.payload?.calculate?.guaranteenFee
					})
				}
			}
		}, 500);
	};
	const handleChangeGuaranteenFee = async (e) => {
		const { name, value } = e.target;
		let reqUpdate = {
			...request,
			package: request.package,
			packageId: request.package.packageId,
			isVip: request.isVip ? "1" : "0",
			customer: { ...request.customer },
			vehicle: { ...request.vehicle },
			discount: request.discount,
			guaranteenFee: value,
			step: 1,
		}
		const rsp = await dispatch(addVehicleContract(reqUpdate));
		if (rsp?.payload?.responseCode === "00000") {
			setQRCode({
				step: 1,
				transactionId: rsp?.payload?.calculate?.transactionId,
				RVPEAmount: rsp?.payload?.calculate?.RVPEAmount,
				sumTotal: rsp?.payload?.calculate?.sumTotal,
				priceAfterDiscount: rsp?.payload?.calculate?.priceAfterDiscount,
				total: rsp?.payload?.calculate?.totalAmount,
				payPerMonth: rsp?.payload?.calculate?.packagePrice,
				feeRegister: rsp?.payload?.calculate?.registerFee,
				total: rsp?.payload?.calculate?.totalAmount,
				discount: rsp?.payload?.calculate?.discount,
				vat: rsp?.payload?.calculate?.vat,
				vatValue: rsp?.payload?.calculate?.vatValue,
				commission: rsp?.payload?.calculate?.commission,
				commissionRate: rsp?.payload?.calculate?.commissionRate,
				vipAmount: rsp?.payload?.calculate?.vipAmount || 0,
				discountPercent: request.discount,
				paymentFee: rsp?.payload?.calculate?.paymentFee,
				repairCost: rsp?.payload?.calculate?.repairCost,
				companyReceiveTotal: rsp?.payload?.calculate?.companyReceiveTotal,
				civelLiability: rsp?.payload?.calculate?.civelLiability,
				guaranteenFee: rsp?.payload?.calculate?.guaranteenFee
			})
		}
		setRequest((prev) => ({
			...prev,
			[name]: value
		}))
	};
	return (
		<div className="page-wrapper dashboard">
			<span className="header-span"></span>
			<DashboardHeader />
			<MobileMenu />
			<DashboardEmployerSidebar />
			<form onSubmit={handleSave}>
				<section className="user-dashboard">
					<div className="dashboard-outer">
						<div className="upper-title-box back-title-group">
							<BackPrevious />
							<h4>{t("contracts.renew")}</h4>
						</div>
						<div className="ls-widget">
							<div className="tabs-box">
								<div className="widget-content p-4">
									<div className="default-form">
										<div className="row">
											<div className="col-12 mb-3"><h5 className="fw-bold">#{t("contracts.life.customer")} {request.vehicle.createDate ? (t("contracts.vehicle.createDate") + ":" + dateToString(request.vehicle.createDate, 'DD/MM/YYYY')) : ''}</h5><hr /></div>
											<div className="col-md-3 form-group">
												<label> {t('contracts.life.agentCode')}<span className="text-danger">*</span></label>
												<DataAutoComplete
													disabled={request.contractNumber != null}
													label="firstName"
													id="agentCode"
													initialData={agentData}
													data={agent}
													autoSelect={true}
													placeholder={t('contract.keyword')}
													handleChange={loadData}
													onSelect={onSelect}
												/>
											</div>
											<div className="col-md-3 form-group">
												<label> {t('contracts.life.firstName')}<span className="text-danger">*</span></label>
												<input
													type="text"
													name="firstName"
													className="form-control-uld"
													placeholder={t('contracts.life.firstName')}
													onChange={(e) => handleChange(e, "customer")}
													value={request.customer?.firstName}
													autoComplete="off"
													required />
											</div>

											<div className="col-md-3 form-group">
												<label> {t('contracts.life.lastName')}<span className="text-danger">*</span></label>
												<input
													type="text"
													name="lastName"
													className="form-control-uld"
													placeholder={t('contracts.life.lastName')}
													onChange={(e) => handleChange(e, "customer")}
													value={request.customer?.lastName}
													autoComplete="off"
													required />
											</div>
											<div className="col-md-3 form-group">
												<label> {t('contracts.vehicle.signedDate')}</label>
												<DatePicker
													minDate={new Date()}
													selected={request.signedDate}
													onChange={(date) => handleDateChange(date, 'signedDate', null)}
													dateFormat="dd/MM/yyyy"
													placeholderText={t('contracts.vehicle.signedDate')}
													className="form-control-uld"
												/>
											</div>


											{/* <div className="col-md-2 form-group">
												<label> {t('contracts.life.dateOfBirth')} <span className="text-danger">*</span> </label>
												<DatePicker
													selected={request.customer?.dateOfBirth}
													onChange={(date) => handleDateChange(date, 'dateOfBirth', "customer")}
													dateFormat="dd/MM/yyyy"
													placeholderText={t('contracts.life.dateOfBirth')}
													className="form-control-uld"
													required
												/>
											</div>

											<div className="col-md-2 form-group">
												<label>{t('contracts.life.gender')} <span className="text-danger">*</span> </label>
												<select className="chosen-single form-select"
													name="gender"
													onChange={(e) => handleChange(e, "customer")}
													value={request.customer?.gender}
													required
												>
													<option key={"m"} value={"m"}>{t("gender.m")}</option>
													<option key={"f"} value={"f"}>{t("gender.f")}</option>
												</select>
											</div> */}

											<div className="col-md-2 form-group">
												<label> {t('contracts.life.phone')} <span className="text-danger">*</span> </label>
												<input
													type="number"
													name="phone"
													className="form-control-uld"
													placeholder={t('contracts.life.phone')}
													onChange={(e) => handleChange(e, "customer")}
													value={request.customer?.phone}
													autoComplete="off"
													required />
											</div>

											<div className="col-md-2 form-group">
												<label> {t('contracts.life.provinceName')} <span className="text-danger">*</span> </label>
												<select className="chosen-single form-select"
													name="provinceId"
													onChange={(e) => handleChange(e, "customer")}
													value={request.customer?.provinceId}
													required
												>
													<option key={0} value="">{t("pleaseSelect")}</option>
													{
														provinceList.map((item) => (
															<option key={item.provinceId} value={item.provinceId}>{item.provinceName}</option>
														))
													}
												</select>
											</div>

											<div className="col-md-2 form-group">
												<label> {t('contracts.life.districtName')} <span className="text-danger">*</span> </label>
												<select className="chosen-single form-select"
													name="districtId"
													onChange={selectedDistrict}
													value={request.customer?.districtId}
													required
												>
													<option key={0} value="">{t("pleaseSelect")}</option>
													{
														districtList['customer'].map((item) => (
															<option key={item.districtId} value={item.districtId}>{item.districtName}</option>
														))
													}
												</select>
											</div>
											<div className="col-md-2 form-group">
												<label> {t('contracts.life.village')} <span className="text-danger">*</span> </label>
												<input
													type="text"
													name="village"
													className="form-control-uld"
													placeholder={t('contracts.life.village')}
													onChange={(e) => handleChange(e, "customer")}
													value={request.customer?.village}
													autoComplete="off" />
											</div>

											<div className="col-md-4 form-group">
												<label>{t('contracts.life.packageType')} <span className="text-danger">*{!request.agentId ? t("uiLabels.selectAgentFirst") : ""}</span> </label>
												<select className="chosen-single form-select"
													name="packageType"
													onChange={selectePackageType}
													value={request?.packageType}
													required
													disabled={!request.agentId}

												>
													<option key={0} value="">{t("pleaseSelect")}</option>
													{

														packageListType.map((item) => (
															<option key={item.id} value={item.id}>{item.nameLa}</option>
														))
													}
												</select>
											</div>
											<div className="col-md-4 form-group">
												<label>{t('contracts.life.package')} <span className="text-danger">*</span> </label>
												{/* <FilterableDropdown
													isDisabled={request.contractNumber}
													options={packageList}
													label={'optionNameLa'}
													valueKey={'packageId'}
													type={packageListTerm}
													value={request?.package}
													onChange={onChangePackage}
													typeDefault={0}
													filteredTypeInput={request?.packageType}
												/> */}
												<FilterableDropdown
													// isDisabled={request.contractNumber}
													options={packageList}
													value={request?.package}
													onChange={onChangePackage}
													label="optionNameLa"
													valueKey="packageId"
												/>
											</div>
											{request.centerAmount.length > 0 && <div className="col-md-2 form-group">
												<label>{t('contracts.vehicle.isRepairCenter')}</label>
												<select className="chosen-single form-select"
													name="isRepairCenter"
													onChange={(e) => handleChangeCenterAmount(e, "vehicle")}
													value={request.vehicle?.isRepairCenter}
												>
													<option key={0} value={-1}>{t("contracts.vehicle.isRepairCenter")}</option>
													{request.centerAmount?.map((center, index) => (
														<option key={index} value={index}>{FormatCurrencys(center)}</option>
													))}
													{/* <option key={0} value={0}>{t("verifyStatus.notVerify")}</option>
													<option key={1} value={1}>{t("verifyStatus.verify")}</option> */}
												</select>
											</div>}
											{request.isVip && <div className="col-md-2 form-group">
												<label>{t('contracts.vehicle.carType')}</label>
												<select className="chosen-single form-select"
													name="vehiclesLegal"
													onChange={(e) => handleChange(e)}
													value={request.vehiclesLegal}
												>
													<option key={0} value={0}>{t("car.vehicleWithDoc")}</option>
													<option key={1} value={1}>{t("car.vehicleWithOutDoc")}</option>
												</select>
											</div>}
											{request.isVip &&
												<div className="col-md-2 form-group">
													<label> {t('contracts.vehicle.vipPercent')} <span className="text-danger">*</span> </label>
													<InputNumberFormat
														type="number"
														name="vipPercent"
														max={10}
														min={0}
														className="form-control-uld"
														placeholder={t('contracts.vehicle.vipPercent')}
														onChange={(e) => handleChange(e, null)}
														onBlur={
															request.vipAmount > 0 ? handleVIP : null
														}
														value={request.vipPercent}
													/>
												</div>}
											{request.isVip &&
												<div className="col-md-2 form-group">
													<label> {t('contracts.vehicle.vipAmount')} <span className="text-danger">*</span> </label>
													<InputNumberFormat
														type="text"
														min={0}
														name="vipAmount"
														className="form-control-uld"
														placeholder={t('contracts.vehicle.vipAmount')}
														onChange={(e) => handleChange(e, null)}
														onBlur={
															request.vipPercent > 0 ? handleVIP : null
														}
														value={request.vipAmount}
														autoComplete="off" />
												</div>}
											{request?.guaranteenFeeArray?.length > 0 &&
												<div className="col-md-2 form-group">
													<label>{t('contracts.vehicle.guaranteenFee')}</label><span className="text-danger">*</span>
													<select className="chosen-single form-select"
														name="guaranteenFee"
														onChange={(e) => handleChangeGuaranteenFee(e)}
														value={request.guaranteenFee}
													>
														<option key={0} value={''}>{t("pleaseSelect")}</option>
														{request.guaranteenFeeArray?.map((item, index) => (
															<option key={index} value={index}>{FormatCurrencys(item)}</option>
														))}
													</select>
												</div>}
											{request?.package?.discount == 1 &&
												<div className="col-md-2 form-group">
													<label> {t('contracts.vehicle.discount')} </label>
													<InputNumberFormat
														type="number"
														name="discount"
														min={0}
														max={100}
														className="form-control-uld"
														placeholder={t('contracts.vehicle.discount')}
														onChange={(e) => handleChange(e, null)}
														onBlur={(e) => {
															handleChangeDiscount(e, null)
														}}
														disabled={request.contractNumber}
														value={request.discount}
														autoComplete="off" />
												</div>}
											<div className="col-md-2 form-group">

											</div>

										</div>
										<div className="row">
											<div className="col-12 mb-3"><h5 className="fw-bold">#{t("contracts.vehicle.info")}</h5><hr /></div>
											{/* <div className="col-12 mt-4"><h5>{t("contracts.vehicle.info")}</h5><hr /></div> */}
											<div className="col-md-2 form-group">
												<label>{t("contracts.vehicle.vehicleBrand")}<span className="text-danger">*</span></label>
												{/* <select className="form-select" name="vehicleBrandId" value={request.vehicle.vehicleBrandId} required onChange={(e) => handleChange(e, "vehicle")}>
													<option key={0} value="">{t("pleaseSelect")}</option>
													{vehicleBrandList?.map(item => (<option value={item.brandId}>{item.brandNameEn}</option>))}
												</select> */}

												<AsyncPaginate
													styles={{
														control: (base, state) => ({
															...base,
															minHeight: 45,
															height: 45,
															background: "#f0f5f7",
															borderColor: state.isFocused
																? "var(--primary-color)"
																: base.borderColor,
															boxShadow: state.isFocused
																? "0 0 0 0.5px var(--primary-color)"
																: "none",
															"&:hover": {
																borderColor: "var(--primary-color)",
															},
														}),
														valueContainer: (base) => ({
															...base,
															height: 45,
															padding: "0 8px",
															fontSize: "14px",
															display: "flex",
															alignItems: "center",   // ✅ ทำให้ placeholder / input อยู่กลางแนวตั้ง
														}),
														input: (base) => ({
															...base,
															margin: 0,
															padding: 0,
															fontSize: "14px",
															alignSelf: "center",    // ✅ จัด input ให้อยู่กลาง
														}),
														placeholder: (base) => ({
															...base,
															margin: 0,
															fontSize: "14px",
															color: "#999",
															position: "absolute",
															top: "50%",
															transform: "translateY(-50%)", // ✅ จัด placeholder ให้อยู่กลางแนวตั้ง
														}),
														menuList: (base) => ({
															...base,
															fontSize: "14px",
															maxHeight: 200,
														}),
													}}
													name="vehicleBrandId"
													value={request.vehicle.vehicleBrand}
													loadOptions={loadBrand}
													onChange={handleChangeVehicleBrandId}
													additional={{
														page: 1,
													}}
													debounceTimeout={500}
													placeholder={t("contracts.vehicle.vehicleBrand")}
													isClearable
												/>

											</div>
											<div className="col-md-2 form-group">
												<label>{t("contracts.vehicle.vehicleModel")}<span className="text-danger">*</span></label>
												<input className="form-control-uld" placeholder={t('contracts.vehicle.vehicleModel')} name="vehicleModel" value={request.vehicle?.vehicleModel} required onChange={(e) => handleChange(e, "vehicle")} />
											</div>
											<div className="col-md-2 form-group">
												<label>{t("contracts.vehicle.licensePlate")}<span className="text-danger">*</span></label>
												<input className="form-control-uld" placeholder={t('contracts.vehicle.licensePlate')} name="licensePlate" value={request.vehicle?.licensePlate} required onChange={(e) => handleChange(e, "vehicle")} />
											</div>
											<div className="col-md-2 form-group">
												<label>{t("contracts.vehicle.vehiclePower")}<span className="text-danger">*</span></label>
												<input className="form-control-uld" placeholder={t('contracts.vehicle.vehiclePower')} name="vehiclePower" value={request.vehicle.vehiclePower} onChange={(e) => handleChange(e, "vehicle")} />
											</div>
											<div className="col-md-2 form-group">
												<label>{t("contracts.vehicle.engineNo")}<span className="text-danger">*</span></label>
												<input className="form-control-uld" placeholder={t('contracts.vehicle.engineNo')} name="engineNo" required value={request.vehicle.engineNo} onChange={(e) => handleChange(e, "vehicle")} />
											</div>
											<div className="col-md-2 form-group">
												<label>{t("contracts.vehicle.vehicleIdentificationNo")}<span className="text-danger">*</span></label>
												<input className="form-control-uld" placeholder={t('contracts.vehicle.vehicleIdentificationNo')} required name="vehicleIdentificationNo" value={request.vehicle.vehicleIdentificationNo} onChange={(e) => handleChange(e, "vehicle")} />
											</div>
											<div className="col-12 col-md-12 form-group">
												<label> {t('contracts.vehicle.imagePath')} <span className="text-danger">*</span> </label>
												<FileUploadGrid
													multiple={true}
													folderName="vehicle"
													filesFromApi={request.vehicle.imagePath || []}
													onChange={(e) => handleImageSelect(e, 'vehicle')}
													accept="image/*,application/pdf"
													required
												/>
											</div>
										</div>
										{/* 
										{
											qrCode.total == 0 ? <div className="col-12 d-flex justify-content-center">
												<div className="m-3" ref={saveButtonRef}>
													<button className="theme-btn btn-style-one w-100" type="submit">
														<i className="fas fa-add"></i>&nbsp;{t("button.save")}
													</button>
												</div>
											</div> : null
										}
										{isStickyVisible && (
											<div className="form-footer-fixed">
												<div className="container d-flex justify-content-center">
													<button className="theme-btn btn-style-one w-auto" type="submit" onClick={() => saveButtonRef.current?.click()}>
														<i className="fas fa-add"></i>&nbsp;{t("button.save")}
													</button>
												</div>
											</div>
										)} */}
									</div>
								</div>
							</div>
						</div>
						{
							qrCode.total ?
								<div className="ls-widget">
									<div className="tabs-box">
										<div className="widget-content p-4">
											<div className="default-form">
												<div className="row">
													<PaymentPage countdownSeconds={maxTime} isDebit={request?.agent?.debit !== 1} onPay={(data) => {
														setRequest((prev) => ({
															...prev,
															inDebt: data.inDebt,
														}))
														saveButtonRef.current?.click()
													}} FormatCurrencys={FormatCurrencys} t={t} qrCode={qrCode} />
													{/* <div className="col-12 d-flex justify-content-center align-items-center flex-column">
																			{qrCode?.value && <div style={{ position: 'relative', width: 300, height: 300 }}>
																				<QRCodeCanvas
																					value={qrCode.value}
																					size={300}
																					bgColor="#ffffff"
																					fgColor="#000000"
																					level="H"
																					includeMargin={true}
																				/>
																				<img
																					src={"/images/lti_logo.png"}
																					alt="logo"
																					style={{
																						position: 'absolute',
																						top: '50%',
																						left: '50%',
																						transform: 'translate(-50%, -50%)',
																						width: 300 * 0.2,
																						height: 300 * 0.2,
																						borderRadius: 8,
																					}}
																				/>
																			</div>}
																			
																			{qrCode?.payPerMonth > 0 && <div className="col-6 row"><h4 className="fw-bold col-md-6">{t('contracts.vehicle.payPerMonth')}:</h4><h4 className="fw-bold text-danger col-md-6">{FormatCurrencys(qrCode?.payPerMonth)} {t("currentcy.kip")}</h4></div>}
																			{qrCode?.discount != 0 && <div className="col-6 row"> <h4 className="fw-bold col-md-6">{t('contracts.vehicle.discount')}:</h4><h4 className="fw-bold text-success col-md-6">{FormatCurrencys(qrCode?.discount)} {t("currentcy.kip")}</h4></div>}
																			{qrCode?.priceAfterDiscount > 0 && <div className="col-6 row"><h4 className="fw-bold col-md-6">{t('contracts.vehicle.priceAfterDiscount')}:</h4><h4 className="fw-bold text-danger col-md-6">{FormatCurrencys(qrCode?.priceAfterDiscount)} {t("currentcy.kip")}</h4></div>}
																			{qrCode?.repairCost > 0 && <div className="col-6 row"><h4 className="fw-bold col-md-6">{t('contracts.vehicle.repairCost')}:</h4><h4 className="fw-bold text-danger col-md-6">{FormatCurrencys(qrCode?.repairCost)} {t("currentcy.kip")}</h4></div>}
																			{qrCode?.civelLiability > 0 && <div className="col-6 row"><h4 className="fw-bold  col-md-6">{t('contracts.vehicle.civelLiability')}:</h4><h4 className="fw-bold text-danger col-md-6">{FormatCurrencys(qrCode?.civelLiability)} {t("currentcy.kip")}</h4></div>}
																			{qrCode?.guaranteenFee > 0 && <div className="col-6 row"><h4 className="fw-bold col-md-6">{t('contracts.vehicle.guaranteenFee')}:</h4><h4 className="fw-bold text-danger col-md-6">{FormatCurrencys(qrCode?.guaranteenFee)} {t("currentcy.kip")}</h4></div>}
																			{qrCode?.sumTotal > 0 && <div className="col-6 row"><h4 className="fw-bold col-md-6">{t('contracts.vehicle.sumTotal')}:</h4><h4 className="fw-bold text-danger col-md-6">{FormatCurrencys(qrCode?.sumTotal)} {t("currentcy.kip")}</h4></div>}
																			{qrCode?.RVPEAmount > 0 && <div className="col-6 row"><h4 className="fw-bold col-md-6">{t('contracts.vehicle.RVPEAmount')}:</h4><h4 className="fw-bold text-danger col-md-6">{FormatCurrencys(qrCode?.RVPEAmount)} {t("currentcy.kip")}</h4></div>}
																			{qrCode?.vatValue > 0 && <div className="col-6 row"><h4 className="fw-bold col-md-6">{t('contracts.vehicle.vatValue')}:</h4><h4 className="fw-bold text-danger col-md-6"> {FormatCurrencys(qrCode?.vatValue)} {t("currentcy.kip")}</h4></div>}
																			{qrCode?.feeRegister > 0 && <div className="col-6 row"><h4 className="fw-bold  col-md-6">{t('contracts.vehicle.feeRegister')}:</h4><h4 className="fw-bold text-danger col-md-6">{FormatCurrencys(qrCode?.feeRegister)} {t("currentcy.kip")}</h4></div>}
																			{qrCode?.commission > 0 && <div className="col-6 row"><h4 className="fw-bold col-md-6">{t('contracts.vehicle.commission')}:</h4><h4 className="fw-bold text-success col-md-6"> -{FormatCurrencys(qrCode?.commission)} {t("currentcy.kip")}</h4></div>}
																			{qrCode?.paymentFee > 0 && <div className="col-6 row"><h4 className="fw-bold  col-md-6">{t('contracts.vehicle.paymentFee')}:</h4><h4 className="fw-bold text-danger col-md-6">{FormatCurrencys(qrCode?.paymentFee)} {t("currentcy.kip")}</h4></div>}
																			{qrCode?.total > 0 && <div className="col-6 row "> <h4 className="fw-bold col-md-6">{t('contracts.vehicle.total')}:</h4><h4 className="fw-bold text-danger col-md-6">{FormatCurrencys(qrCode?.total)} {t("currentcy.kip")}</h4></div>}
																			{qrCode?.companyReceiveTotal > 0 && <div className="col-6 row"><h4 className="fw-bold col-md-6">{t('contracts.vehicle.companyReceiveTotal')}:</h4><h4 className="fw-bold text-danger col-md-6">{FormatCurrencys(qrCode?.companyReceiveTotal)} {t("currentcy.kip")}</h4></div>}
						
																		</div> */}
												</div>
											</div>
										</div>
									</div>
								</div> : null
						}
					</div>
				</section>
			</form>
			<CopyrightFooter />
		</div >
	);
};

export default Index;
